import { createClient } from '@supabase/supabase-js';

// ============================================================
//  PASTE YOUR SUPABASE KEYS HERE
//  Get them from: Supabase dashboard → Project Settings → API
// ============================================================
const SUPABASE_URL = 'https://nfrwghvttobragepipxp.supabase.co';
const SUPABASE_ANON_KEY = 'sb_publishable_y2ocU2WbTeYYydZ0Ztrdwg_LoB1O28Y';

// Admin password for the blog upload page. Change this before going live.
export const ADMIN_PASSWORD = 'lms@admin2025';

// Name of the storage bucket for blog cover images (create this in Supabase).
export const BLOG_BUCKET = 'blog-images';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
